	export enum SsrsReportFilterTypeEnum {
		DateRange = 1,
		Clinic = 2,
		Region = 3,
		Date = 4,
		Patient = 5
	}
